import BaseFilter from "./BaseFilter";
import 'select2';
export default class SelectFilter extends BaseFilter {
    constructor($node) {
        super();
        this.$node = $node;
        const labelnoresult = $node.data('labelnoresult');
        this.$node.select2({
            closeOnSelect: false,
            language: {
                noResults: function () {
                    return labelnoresult;
                }
            },
        });
        this.filterProperty = $node.data('filterproperty');
    }
    match($item) {
        const nodeValue = this.$node.val();
        const valueStr = nodeValue === null || nodeValue === void 0 ? void 0 : nodeValue.toString();
        if (!valueStr)
            return true;
        const value = nodeValue === null || nodeValue === void 0 ? void 0 : nodeValue.toString().split(',');
        if (value === undefined || value.length == 0)
            return true;
        const data = String($item.data(this.filterProperty));
        return value.includes(data);
    }
}
